import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Carousel from 'nuka-carousel'
import { useTranslation } from 'react-i18next'

import { Testimonial, TestimonialData } from './Testimonial'
import { SectionTitle } from '../common/typography'
import { BlueSection } from '../common/style/Section'
import { NavigationButton, Left, Right, Dots } from './SliderControls'
import { googleAnalytics } from '../common/analytics/GoogleAnalytics'

const Testimonials = () => {
  const [testimoniesToShow, setTestimoniesToShow] = useState(
    getSlidesToShow(window.innerWidth)
  )
  const [t] = useTranslation('testimonials')
  useEffect(() => {
    const handleResize = () => {
      setTestimoniesToShow(getSlidesToShow(window.innerWidth))
    }
    window.addEventListener('resize', handleResize)
    return function cleanup() {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <TestimonialSection>
      <SectionTitle light={true}>{t('title')}</SectionTitle>
      <Carousel
        slidesToShow={testimoniesToShow}
        width="95%"
        speed={100}
        easing="easeQuadInOut"
        dragging={true}
        framePadding={window.innerWidth > 700 ? '40px' : '0px'}
        slidesToScroll="auto"
        afterSlide={() => {
          googleAnalytics.event({
            category: 'more info',
            label: 'navigate testimonials',
            action: 'click',
          })
        }}
        renderCenterLeftControls={({ previousSlide, currentSlide }) =>
          window.innerWidth > 700 && (
            <NavigationButton
              onClick={previousSlide}
              disabled={currentSlide === 0}
            >
              <Left />
            </NavigationButton>
          )
        }
        renderCenterRightControls={({
          nextSlide,
          currentSlide,
          slidesToShow,
          slideCount,
        }) =>
          window.innerWidth > 700 && (
            <NavigationButton
              onClick={nextSlide}
              disabled={currentSlide + slidesToShow === slideCount}
            >
              <Right />
            </NavigationButton>
          )
        }
        renderBottomCenterControls={({
          slideCount,
          slidesToShow,
          currentSlide,
        }) => (
          <Dots
            activeIndex={Math.ceil(currentSlide / slidesToShow)}
            count={Math.ceil(slideCount / slidesToShow)}
          />
        )}
      >
        {t<TestimonialData[]>('quotes', { returnObjects: true }).map(
          (testimonial, index) => (
            <Testimonial testimonial={testimonial} key={index} />
          )
        )}
      </Carousel>
    </TestimonialSection>
  )
}

export default Testimonials

export const TestimonialSection = styled(BlueSection)`
  padding-bottom: 60px;
  padding-top: 60px;
`

const getSlidesToShow = (width: number) => {
  if (width > 1000) {
    return 3
  }
  if (width > 700) {
    return 2
  }
  return 1
}
